import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import FeaturedPosts from './components/FeaturedPosts';
import LatestIssues from './components/LatestIssues';
import AboutSnippet from './components/AboutSnippet';

const HomePage = () => (
  <div className="min-h-screen">
    <Navbar />
    <main>
      <Hero />
      <FeaturedPosts />
      <LatestIssues />
      <AboutSnippet />
    </main>
    <Footer />
  </div>
);

export default HomePage;
